import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    mixins: [mainRegistrationMixin],
    computed: {

        groupRegistrarLink() {
            return "https://" + window.location.host + "/reg/anmeldung/" + this.eventData.id + "/start?groupRegToken=" + this.registrationData.groupRegistrarToken;
        },
        groupParticipantLink() {
            return "https://" + window.location.host + "/reg/anmeldung/" + this.eventData.id + "/start?groupParToken=" + this.registrationData.groupParticipantToken;
        },

        groupRegistrationCreationMode: {
            get: function () {
                return this.$store.state.registration.groupRegistrationCreationMode
            }
        },

        isGroupRegistrar() {
            return this.$store.getters['registration/isGroupRegistrar']
        },

        isGroupParticipant() {
            return this.$store.getters['registration/isGroupParticipant']
        },

        groupRegistrarToken: {
            get: function () {
                return this.$store.state.registration.groupRegistrarToken
            },
            set: function (value) {
                this.$store.commit('registration/setGroupRegistrarToken', value)
            }
        },

        groupParticipantToken: {
            get: function () {
                return this.$store.state.registration.groupParticipantToken
            },
            set: function (value) {
                this.$store.commit('registration/setGroupParticipantToken', value)
            }
        },

        groupName: {
            get: function () {
                return this.registrationData.groupName
            },
            set: function (value) {
                this.setRegistrationProp('groupName', value)
            }
        },

        groupRegistrarMail: {
            get: function () {
                return this.registrationData.groupRegistrarMail
            },
            set: function (value) {
                this.setRegistrationProp('groupRegistrarMail', value)
            }
        },

    },
    methods: {
        initGroupRegistrationCreationMode(){
            this.$store.commit('registration/initGroupRegistrationCreationMode')
        },
    }
}
